module.exports = __webpack_public_path__ + "img/2-1.5159430e.png";